// Central gate for the Video Creative status pollers (useAdPipeline,
// AdBrowser, GeneratedAdsHistory).
//
// Background: these pollers hit Snowflake every 10–15s while work is in flight.
// A dashboard left open kept the warehouse resumed 24/7 (resume-churn against
// Snowflake's 60s minimum billing), which drove the compute_wh cost spike.
//
// Polling is allowed only when BOTH:
//   1. the tab is visible (not a background tab), and
//   2. the user has interacted within the last IDLE_LIMIT_MS.
//
// Any real interaction — or refocusing the tab — immediately re-arms polling.
// The pollers' intervals keep ticking but become cheap no-ops while gated; the
// next tick after the user returns resumes live polling (≤ one interval later).

const IDLE_LIMIT_MS = 5 * 60 * 1000; // pause after 5 min of no user action

let lastActivity = Date.now();
let installed = false;

function markActive() {
  lastActivity = Date.now();
}

function install() {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'];
  for (const evt of events) {
    window.addEventListener(evt, markActive, { passive: true });
  }
  // Refocusing the tab counts as activity so polling resumes right away.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) markActive();
  });
}

install();

/** True when the status pollers should hit the backend right now. */
export function shouldPoll(): boolean {
  if (typeof document !== 'undefined' && document.hidden) return false;
  return Date.now() - lastActivity < IDLE_LIMIT_MS;
}

/**
 * True when polling is currently gated off (hidden tab or idle user).
 * Lets the UI show a "live updates paused" hint next to in-flight rows.
 */
export function isPollingPaused(): boolean {
  return !shouldPoll();
}
